// extracted by mini-css-extract-plugin
module.exports = {"term":"term_term__KIcMt","termSelected":"term_termSelected__X70gR"};